import React from 'react';
import {useParams,useNavigate} from 'react-router-dom';
import EventoWizard from './EventoWizard';
export default function ConfigurarEvento(){const {eventoId}=useParams(),navigate=useNavigate();return <EventoWizard key={eventoId} eventoId={eventoId} pasoInicial="comercial-activar" onCerrar={()=>navigate('/eventos')} onPublicado={()=>navigate('/eventos')}/>;}
